import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["zoom", "width", "height", "children"];
/** @jsx jsx */

import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default (function (_ref) {
  var zoom = _ref.zoom,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return jsx("div", _extends({}, props, {
    sx: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      color: 'text',
      bg: 'background',
      variant: 'styles.Slide',
      width: width,
      height: height,
      zoom: zoom
    }
  }), children);
});